import { render, staticRenderFns } from "./VideoGames.vue?vue&type=template&id=362ba644"
import script from "./VideoGames.vue?vue&type=script&lang=ts"
export * from "./VideoGames.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports